const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=cloudMainRequestMan]');
// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index) {
    let urlImg = '';
    if(item.image)
      urlImg = `${window.appSettings.xhrSettings.urlContentYCloud}creators/preview_300/${item.image}.jpg`;
    else
      urlImg = '';

    let filmographyHTML = 'Фильмография не заполнена.';
    if(item.filmography)
      filmographyHTML = this.ifnull(item.filmography);


  return `<div class = "mainRejCard row p-0 " pID=${index} name="creator-${item.cid}"> 
              <div class = "column m-0 w-30 p-10"  name="creator-${index}-img">
                <img src="${urlImg}"  name="creator-${item.cid}-img">
              </div>
              <div class = "column m-0 p-10 w-70"   name="creator-${item.cid}-Name">
                <div class="row m-0 w-100 p-1"   >
                  <b class="column m-0 p-1" name="creator-${item.cid}-Surname"> ${this.ifnull(item.nameF)}   </b>
                  <b class="column m-0 p-1" name="creator-${item.cid}-Name">${this.ifnull(item.nameI)}   </b>
                  <b class="column m-0 p-1" name="creator-${item.cid}-Patronymic">${this.ifnull(item.nameO)}  </b>
                </div>
                <div class="row m-0 p-1"  name="creator-${item.cid}-bio">
                  <p name="creator-${item.cid}-bio">${this.ifnull(item.bio)}</p>
                </div>
                <div class="row m-0 p-0">
                  <div class="filmography row" name="creator-${item.cid}-Filmography">
                    <div class="column w-20">
                      <img src="/img/camera.png">
                    </div>
                    <p name="creator-${item.cid}-filmography" class="  w-80"> ${filmographyHTML}</p>
                  </div>
                </div>

               
                <div class="row m-0 p-0">
                  <div class=" m-0 p-1" name="creator-${item.cid}-Year">
                    ${this.ifnull(item.bYear)} 
                  </div>
                  <div class=" m-0 p-1 ml-3" name="creator-${item.cid}-BirthPlace">
                  ${this.ifnull(item.bPlace)}
                  </div>
                </div>
                <div class="row m-0 p-0">
                  <div class=" m-1 p-1 " name="creator-${item.cid}-Mail">
                    ${this.ifnull(item.mail)}
                  </div>
                  <div class=" m-1 p-1 ml-3" name="creator-${item.cid}-Phone">
                    ${this.ifnull(item.phone)}
                  </div>
                </div>
                <div class="row m-0 p-0">
                  <div class=" m-1 p-1 " name="creator-${item.cid}-WorkPlace">
                    ${this.ifnull(item.wPlace)}
                  </div>
                  <div class=" m-1 p-1 ml-3" name="creator-${item.cid}-Site">
                    <a href="${this.ifnull(item.site)}" target="_blank" name="creator-${item.cid}-Site">${this.ifnull(item.site)} </a>
                  </div>
                </div>
              </div
          </div>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay) {

    let header = '';
    let body = '';
    let footer = '';
    this.cleanContainer();

    if(dataToDisplay){
      if(dataToDisplay.nextID){
        if(parseInt(dataToDisplay.type, 10) === 0)
           header = `<div class="row w-100 m-0 p-1">Режиссер:
                        <b class="ml-1">${this.ifnull(dataToDisplay.detail.nameF)} 
                                        ${this.ifnull(dataToDisplay.detail.nameI)} 
                                        ${this.ifnull(dataToDisplay.detail.nameO)}
                        </b>
                      </div>`;
        else if(parseInt(dataToDisplay.type, 10) === 1) 
            header = `<div class="row w-100 m-0 p-1">Студия - производитель:
                        <b class="ml-1">${this.ifnull(dataToDisplay.detail.name)}
                        </b>
                      </div>
                      <div class="row w-100 m-0 p-1">Адрес:
                        <b class="ml-1">${this.ifnull(dataToDisplay.detail.adress)}
                        </b>
                      </div>
                      <div class="row w-100 m-0 p-1">Контактное лицо:
                        <b class="ml-1">${this.ifnull(dataToDisplay.detail.delegate)}
                        </b>
                      </div>`;
         else if(parseInt(dataToDisplay.type, 10) === 2) 
            header = `<div class="row w-100 m-0 p-1">Представитель:
                        <b class="ml-1">${this.ifnull(dataToDisplay.detail.name)}</b>
                      </div> `;         
        


      } else
        header = `<b class="row w-100 m-0" style="padding: 5px !important;">Быстрая заявка - без регистрации</b>`;

      
      body = `<div class="row w-100 m-0 p-0">
                <div class="w-50 p-1">Телефон: ${dataToDisplay.phone}</div>
                <div class="w-50 p-1">E-mail: ${dataToDisplay.mail}</div>
              </div>`;

      if(dataToDisplay.detail.wPlace)
        footer = `<div class="row w-100 m-1 p-0">Проф. учреждение: ${this.ifnull(dataToDisplay.detail.wPlace)} </div>`;
          
      if(dataToDisplay.detail.site)
        footer = `${footer}
                 <div class="row w-100 m-0 p-1"> Сайт: <a  class="ml-1" href="${this.ifnull(dataToDisplay.detail.site)}">${this.ifnull(dataToDisplay.detail.site)} </a> </div>`;

        footer += `<div class="row w-100 m-0 p-0 mt-1">
                    <div class="w-50 p-1">Дата регистрации: ${tools.dateStringShort(dataToDisplay.regTime)}</div>
                    <div class="w-50 p-1">Последняя активность: <b>${tools.dateStringFull(dataToDisplay.lastActivity)}</b></div>
                  </div>`;
      // dataToDisplay.forEach((item, index) => htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    }
    htmlBody.innerHTML = `${header}${body}${footer}`;
  },

/*
  "mail": "m.stepunina@gmail.com",
            "phone": 972533691855,
            "type": 0,
            "status": 1,
            "nextID": 38,
            "detail": {
                "nameI": "Мария",
                "nameF": "Степунина",
                "nameO": "Александровна",
                "wPlace": null,
                "phone": 972533691855,
                "mail": "m.stepunina@gmail.com",
                "site": "https://mstepunina.wixsite.com/portfolio"
            }*/
  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
